export const MORSE_TO_CHAR: Record<string, string> = {
    '.-': 'A',
    '-...': 'B',
    '-.-.': 'C',
    '-..': 'D',
    '.': 'E',
    '..-.': 'F',
    '--.': 'G',
    '....': 'H',
    '..': 'I',
    '.---': 'J',
    '-.-': 'K',
    '.-..': 'L',
    '--': 'M',
    '-.': 'N',
    '---': 'O',
    '.--.': 'P',
    '--.-': 'Q',
    '.-.': 'R',
    '...': 'S',
    '-': 'T',
    '..-': 'U',
    '...-': 'V',
    '.--': 'W',
    '-..-': 'X',
    '-.--': 'Y',
    '--..': 'Z',
    '-----': '0',
    '.----': '1',
    '..---': '2',
    '...--': '3',
    '....-': '4',
    '.....': '5',
    '-....': '6',
    '--...': '7',
    '---..': '8',
    '----.': '9',
    '.-.-.-': '.',
    '--..--': ',',
    '..--..': '?',
    '.----.': "'",
    '-.-.--': '!',
    '-..-.': '/',
    '-.--.': '(',
    '-.--.-': ')',
    '.-...': '&',
    '---...': ':',
    '-.-.-.': ';',
    '-...-': '=',
    '.-.-.': '+',
    '-....-': '-',
    '..--.-': '_',
    '.-..-.': '"',
    '...-..-': '$',
    '.--.-.': '@',
};

export const CHAR_TO_MORSE: Record<string, string> = Object.entries(MORSE_TO_CHAR).reduce(
    (acc, [symbols, char]) => {
        acc[char] = symbols;
        return acc;
    },
    {} as Record<string, string>,
);

export function textToMorse(text: string): string {
    return text
        .toUpperCase()
        .split('\n')
        .map((line) =>
            line
                .split(/\s+/)
                .filter(Boolean)
                .map((word) =>
                    word
                        .split('')
                        .map((c) => CHAR_TO_MORSE[c])
                        .filter(Boolean)
                        .join(' '),
                )
                .filter(Boolean)
                .join(' / '),
        )
        .join('\n');
}

export function morseToText(morse: string): string {
    return morse
        .split('\n')
        .map((line) =>
            line
                .split(/\s*\/\s*/)
                .map((word) =>
                    word
                        .trim()
                        .split(/\s+/)
                        .filter(Boolean)
                        .map((sym) => MORSE_TO_CHAR[sym] ?? '?')
                        .join(''),
                )
                .filter(Boolean)
                .join(' '),
        )
        .join('\n');
}
